
import { defineComponent } from "vue";
import { urlToImg, loadFileAsBlobURL } from "../../utils/canvas";
import Button from "./Button.vue";
import File from "../icons/File.vue";

export default defineComponent({
  components: {
    Button, File,
  },
  props: {
    label: { type: String, default: undefined },
  },
  emits: [
    "load",
  ],
  data() {
    return {
      file: null as File | null,
    };
  },
  methods: {
    onClick(): void {
      (this.$refs.input as HTMLInputElement).click();
    },
    onChange(e: { target: { files: FileList } }): void {
      if (e.target.files[0]) {
        this.file = e.target.files[0];
        loadFileAsBlobURL(this.file).then((blobUrl) => {
          urlToImg(blobUrl, (img) => this.$emit("load", img));
        });
      }
    },
  },
});
